import { Link } from "react-router-dom";
import styles from "./Button.module.css";

export default function Button({
  to,
  href,
  onClick,
  variant = "primary",
  size = "md",
  children,
  className = "",
  type = "button",
  ...rest
}) {
  const cls = [styles.btn, styles[variant], styles[size], className]
    .filter(Boolean)
    .join(" ");
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href)
    return (
      <a
        href={href}
        className={cls}
        target={href.startsWith("http") ? "_blank" : undefined}
        rel={href.startsWith("http") ? "noopener" : undefined}
        {...rest}
      >
        {children}
      </a>
    );
  return (
    <button type={type} className={cls} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}
